import axios from 'axios';

export default {
  async list() {
    return axios.get('/api/v1/audiences').then((response) => response.data);
  },
};
